import React, { useCallback } from "react";
import { Col, Form, Row, Input, Select, List, Space, Button, Card, notification, Divider } from "antd";
import { useParams } from "react-router-dom";
import { formateStringToKey } from "../../../../Service";
import { _Filter_Types } from "../../../../../Home/FiltersData";
import { omit } from "lodash";
import { TenantService } from "../../../../../../Services";

export const CheckBoxFilterForm = ({ selectedKey, uniqueValues, filterType, section, closeForm, mode, filter }) => {
	const { tenantName } = useParams();
	const [form] = Form.useForm();

	// const onValuesChange = changedValues => {
	// 	// Handle updates when filterValues changes
	// 	if (changedValues._Label && filterType === _Filter_Types.Recursive) {
	// 		const label = changedValues._Label;
	// 		form.setFieldsValue({
	// 			_ApiTag: formateStringToKey(label)
	// 		});
	// 	}
	// 	if (changedValues.filterValues) {
	// 		const SELECT_ALL = "__SELECT_ALL__";
	// 		const UNSELECT_ALL = "__UNSELECT_ALL__";

	// 		let updatedValues = changedValues.filterValues;

	// 		// Handle Select All / Unselect All
	// 		if (updatedValues.includes(SELECT_ALL)) {
	// 			updatedValues = uniqueValues;
	// 		} else if (updatedValues.includes(UNSELECT_ALL)) {
	// 			updatedValues = [];
	// 		}
	// 		// Get current _Childrens from the form
	// 		const currentChildren = form.getFieldValue("_Childrens") || [];

	// 		// Generate new _Childrens while preserving manually edited labels
	// 		const newChildren = changedValues.filterValues.map(value => {
	// 			const existingChild = currentChildren.find(child => child._ApiTag === formateStringToKey(value));
	// 			return {
	// 				...existingChild,
	// 				_Label: existingChild?._Label || value, // Preserve edited label or use default
	// 				_ApiTag: value
	// 				// _Type: filterType
	// 			};
	// 		});

	// 		// Update _Childrens in the form
	// 		form.setFieldsValue({
	// 			_Childrens: newChildren
	// 		});
	// 	}
	// };

	const onValuesChange = changedValues => {
		if (changedValues._Label && filterType === _Filter_Types.Recursive) {
			const label = changedValues._Label;
			form.setFieldsValue({
				_ApiTag: formateStringToKey(label)
			});
		}

		if (changedValues.filterValues) {
			const SELECT_ALL = "__SELECT_ALL__";
			const UNSELECT_ALL = "__UNSELECT_ALL__";

			let updatedValues = changedValues.filterValues;

			// Handle Select All / Unselect All
			if (updatedValues.includes(SELECT_ALL)) {
				updatedValues = uniqueValues;
			} else if (updatedValues.includes(UNSELECT_ALL)) {
				updatedValues = [];
			}

			form.setFieldsValue({
				filterValues: updatedValues
			});

			const currentChildren = form.getFieldValue("_Childrens") || [];

			const newChildren = updatedValues.map(value => {
				const existingChild = currentChildren.find(child => child._ApiTag === formateStringToKey(value));
				return {
					...existingChild,
					_Label: existingChild?._Label || value,
					_ApiTag: value
				};
			});

			form.setFieldsValue({
				_Childrens: newChildren
			});
		}
	};

	const updateFilter = useCallback(
		async newFilter => {
			const _id = filter._id;
			if (
				newFilter.clientApiTag &&
				typeof newFilter.clientApiTag === "string" &&
				newFilter.clientApiTag.trim().length > 0
			) {
				newFilter._extra = {
					key: newFilter._ApiTag,
					dbKey: newFilter.clientApiTag,
					value: true
				};
			}
			const result = await TenantService.updateFilter({
				tenantName,
				filter: {
					_id,
					...newFilter
				}
			});
			if (result.data) {
				notification.success({ message: "Filter updated successfully" });
				closeForm && closeForm();
				return;
			}
			notification.error({ message: "Failed to update filter. Please Try Again." });
		},
		[tenantName, filter, closeForm]
	);

	const addFilter = useCallback(
		async filter => {
			if (
				filter.clientApiTag &&
				typeof filter.clientApiTag === "string" &&
				filter.clientApiTag.trim().length > 0
			) {
				filter._extra = {
					key: filter._ApiTag,
					dbKey: filter.clientApiTag,
					value: true
				};

				delete filter.clientApiTag;
			}

			const result = await TenantService.addFilter({ tenantName, filter, sectionId: section._id });

			if (result.data) {
				form.resetFields();
				notification.success({ message: "Filter added successfully" });
				closeForm && closeForm();
				return;
			}

			notification.error({ message: "Failed to add filter. Please Try Again." });
		},
		[tenantName, section, closeForm]
	);

	const onFinish = async values => {
		let filter = omit(values, ["filterValues"]);
		if (mode === "Add") {
			addFilter(filter);
			return;
		}
		if (mode === "Update") {
			updateFilter(filter);
			return;
		}
	};
	return (
		<Row>
			<Col span={24}>
				<Form
					initialValues={
						mode === "Update"
							? {
									...filter,
									filterValues: filter?._Childrens?.map(child => child._ApiTag),
									_Childrens: filter?._Childrens,
									...(formateStringToKey(selectedKey) !== filter?._ApiTag &&
										filterType !== "recursive" && {
											filterValues: [],
											_Childrens: []
										}),
									_Type: filterType,
									_Label: filter?._Label || selectedKey,
									_ApiTag: formateStringToKey(selectedKey || filter?._Label),
									clientApiTag: filter?._extra?.dbKey
							  }
							: {
									_Type: filterType,
									_Label: selectedKey,
									clientApiTagRelation: selectedKey,
									_ApiTag: formateStringToKey(selectedKey),
									_Childrens: []
							  }
					}
					labelCol={{
						span: 8
					}}
					wrapperCol={{
						span: 14
					}}
					layout="horizontal"
					form={form}
					onFinish={onFinish}
					onValuesChange={onValuesChange}
					style={{
						maxWidth: 1000,
						border: "1px solid #e8e8e8",
						padding: "20px",
						borderRadius: "8px"
					}}
				>
					{/* Input Filter Name */}
					<Form.Item
						label="Filter Name"
						name="_Label"
						rules={[{ required: true, message: "Please input filter name!" }]}
					>
						<Input />
					</Form.Item>

					{/* Input Filter Api Tag */}
					<Form.Item
						label="Filter Api Tag"
						name="_ApiTag"
						rules={[{ required: true, message: "Please input filter key!" }]}
					>
						<Input disabled />
					</Form.Item>

					{/* Make A default Selected Value _Type */}
					<Form.Item
						label="Filter Type"
						name="_Type"
						rules={[{ required: true, message: "Please input filter type!" }]}
					>
						{/* Input */}
						<Input disabled />
					</Form.Item>

					{[_Filter_Types.Checkbox, _Filter_Types.Radio].includes(filterType) && (
						<>
							<Form.Item label="Clinet API Tag" name="clientApiTag" rules={[{ required: false }]}>
								<Input />
							</Form.Item>

							<Form.Item
								hidden
								label="Client Relation Key"
								name="clientApiTagRelation"
								rules={[{ required: false }]}
							>
								<Input disabled />
							</Form.Item>
						</>
					)}

					{[_Filter_Types.Checkbox, _Filter_Types.Radio, _Filter_Types.Recursive].includes(filterType) && (
						<Form.Item
							label="Filter Values"
							name="filterValues"
							rules={[{ required: true, message: "Please select filter values!" }]}
						>
							<Select
								mode="multiple"
								style={{ width: "100%" }}
								placeholder="Please select"
								allowClear
								maxTagCount={2}
								dropdownRender={menu => (
									<>
										<div style={{ padding: 8 }}>
											<Button
												type="link"
												size="small"
												onClick={() => {
													const allValues = uniqueValues.filter(Boolean);
													form.setFieldsValue({ filterValues: allValues });
													onValuesChange({ filterValues: allValues });
												}}
											>
												🔘 Select All
											</Button>
											<Button
												type="link"
												size="small"
												onClick={() => {
													form.setFieldsValue({ filterValues: [] });
													onValuesChange({ filterValues: [] });
												}}
											>
												🚫 Unselect All
											</Button>
										</div>
										<Divider style={{ margin: "4px 0" }} />
										{menu}
									</>
								)}
							>
								{uniqueValues?.map(value => (
									<Select.Option key={value} value={value}>
										{value}
									</Select.Option>
								))}
							</Select>
						</Form.Item>
					)}

					{/* Dynamically Generated Children */}

					{[_Filter_Types.Checkbox, _Filter_Types.Radio].includes(filterType) && (
						<Form.List name="_Childrens">
							{fields => (
								<>
									{/* Header for List */}
									<div style={{ display: "flex", padding: "10px 16px", background: "#f0f0f0" }}>
										<div style={{ flex: 1, fontWeight: "bold" }}>Label</div>
										<div style={{ flex: 1, fontWeight: "bold" }}>API Tag</div>
									</div>
									<List
										bordered
										style={{
											maxHeight: "200px",
											overflowY: "auto",
											backgroundColor: "#fafafa"
										}}
										dataSource={fields}
										renderItem={({ key, name, fieldKey, ...restField }) => (
											<List.Item key={key} style={{ display: "flex", alignItems: "center" }}>
												<div style={{ flex: 1, paddingRight: "8px" }}>
													<Form.Item
														{...restField}
														name={[name, "_Label"]}
														fieldKey={[fieldKey, "_Label"]}
														rules={[{ required: true, message: "Please input label!" }]}
													>
														<Input placeholder="Label" />
													</Form.Item>
												</div>
												<div style={{ flex: 1, paddingLeft: "8px" }}>
													<Form.Item
														{...restField}
														name={[name, "_ApiTag"]}
														fieldKey={[fieldKey, "_ApiTag"]}
														rules={[
															{ required: true, message: "API tag cannot be empty!" }
														]}
													>
														<Input placeholder="API Tag" disabled />
													</Form.Item>
												</div>
											</List.Item>
										)}
									/>
								</>
							)}
						</Form.List>
					)}
					{[_Filter_Types.Recursive].includes(filterType) && (
						<Form.List name="_Childrens">
							{(fields, { remove }) => (
								<>
									{/* Header for Parent Fields */}
									<div style={{ display: "flex", padding: "10px 16px", background: "#f0f0f0" }}>
										<div style={{ flex: 1, fontWeight: "bold" }}>Label</div>
										<div style={{ flex: 1, fontWeight: "bold" }}>API Tag</div>
										<div style={{ flex: 1, fontWeight: "bold" }}>Type</div>
										<div style={{ flex: 1, fontWeight: "bold" }}>Actions</div>
									</div>

									<List
										bordered
										style={{ marginBottom: "16px", backgroundColor: "#fafafa" }}
										dataSource={fields}
										renderItem={({ key, name, fieldKey, ...restField }) => (
											<Card
												key={key}
												style={{
													marginBottom: "16px",
													borderRadius: "8px",
													boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)"
												}}
											>
												{/* Parent Input Fields */}
												<div style={{ display: "flex", alignItems: "center", gap: "16px" }}>
													<div style={{ flex: 1 }}>
														<Form.Item
															{...restField}
															name={[name, "_Label"]}
															fieldKey={[fieldKey, "_Label"]}
															rules={[{ required: true, message: "Please input label!" }]}
														>
															<Input placeholder="Label" />
														</Form.Item>
													</div>

													<div style={{ flex: 1 }}>
														<Form.Item
															{...restField}
															name={[name, "_ApiTag"]}
															fieldKey={[fieldKey, "_ApiTag"]}
															rules={[
																{ required: true, message: "API tag cannot be empty!" }
															]}
														>
															<Input placeholder="API Tag" disabled />
														</Form.Item>
													</div>

													<div style={{ flex: 1 }}>
														<Form.Item
															{...restField}
															name={[name, "_Type"]}
															fieldKey={[fieldKey, "_Type"]}
															rules={[
																{ required: true, message: "Please select a type!" }
															]}
															initialValue={_Filter_Types.Checkbox}
														>
															<Select
																placeholder="Select Type"
																style={{ width: "100%" }}
																allowClear
															>
																<Select.Option value={_Filter_Types.Checkbox}>
																	{_Filter_Types.Checkbox}
																</Select.Option>
																<Select.Option value={_Filter_Types.MINMAX}>
																	{_Filter_Types.MINMAX}
																</Select.Option>
															</Select>
														</Form.Item>
													</div>

													<Button type="danger" onClick={() => remove(name)}>
														Remove
													</Button>
												</div>

												{/* Nested Children for Each Parent */}

												<div style={{ marginTop: "16px" }}>
													<div style={{ marginBottom: "8px", fontWeight: "bold" }}>
														Nested Children:
													</div>
													<Form.List
														name={[name, "_Childrens"]}
														rules={[
															{ required: true, message: "Please select filter values!" }
														]}
													>
														{(nestedFields, { add: addNested, remove: removeNested }) => (
															<>
																<div
																	style={{
																		maxHeight: "200px",
																		overflowY: "auto",
																		padding: "8px",
																		border: "1px solid #d9d9d9",
																		borderRadius: "8px",
																		backgroundColor: "#fff"
																	}}
																>
																	{nestedFields.map(
																		({
																			key: nestedKey,
																			name: nestedName,
																			fieldKey: nestedFieldKey,
																			...nestedRestField
																		}) => (
																			<Card
																				key={nestedKey}
																				style={{
																					marginBottom: "8px",
																					padding: "16px",
																					border: "1px solid #d9d9d9",
																					borderRadius: "8px"
																				}}
																			>
																				<div
																					style={{
																						display: "flex",
																						alignItems: "center",
																						gap: "16px",
																						flexWrap: "wrap"
																					}}
																				>
																					{/* Nested Label */}
																					<Form.Item
																						{...nestedRestField}
																						name={[nestedName, "_Label"]}
																						fieldKey={[
																							nestedFieldKey,
																							"_Label"
																						]}
																						rules={[
																							{
																								required: true,
																								message:
																									"Please input label!"
																							}
																						]}
																					>
																						<Input placeholder="Label" />
																					</Form.Item>

																					{/* Nested API Tag */}
																					<Form.Item
																						{...nestedRestField}
																						name={[nestedName, "_ApiTag"]}
																						fieldKey={[
																							nestedFieldKey,
																							"_ApiTag"
																						]}
																						rules={[
																							{
																								required: true,
																								message:
																									"API tag cannot be empty!"
																							}
																						]}
																					>
																						<Input placeholder="API Tag" />
																					</Form.Item>

																					<Button
																						type="danger"
																						onClick={() =>
																							removeNested(nestedName)
																						}
																					>
																						Remove
																					</Button>
																				</div>
																			</Card>
																		)
																	)}
																</div>
																<Button
																	type="primary"
																	style={{ marginTop: "8px" }}
																	onClick={() =>
																		addNested({ _Label: "", _ApiTag: "" })
																	}
																>
																	Add Child
																</Button>
															</>
														)}
													</Form.List>
												</div>
											</Card>
										)}
									/>
								</>
							)}
						</Form.List>
					)}
					{/* {[_Filter_Types.MINMAX].includes(filterType) && (
						// for Min Max Filter just show nothing
					)} */}

					<Form.Item
						wrapperCol={{
							span: 24
						}}
						style={{ textAlign: "center", marginTop: "2rem" }}
					>
						<Space>
							<Button type="primary" htmlType="submit">
								{mode === "Update" ? "Update" : "Add"}{" "}
							</Button>
							<Button onClick={closeForm}>Cancel</Button>
							<Button htmlType="button" onClick={() => form.resetFields()}>
								Reset
							</Button>
						</Space>
					</Form.Item>
				</Form>
			</Col>
		</Row>
	);
};

export default CheckBoxFilterForm;
